import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface FailedLabelProps {
  errorMessages: string | null
}

export const FailedLabel = ({ errorMessages }: FailedLabelProps) => (
  <Box flexDirection="row" gap="s8" justifyContent="flexEnd" alignItems="center">
    <Text.Normal color="grey700" size="100">
      {errorMessages
        ? `${i18n.t('integrations.syncable_status.failed')}. ${errorMessages}`
        : i18n.t('integrations.syncable_status.failed')}
    </Text.Normal>
  </Box>
)
